import { IEventsState } from '@app/states/events/states/events-state.interface';

export const EVENTS_STATE_DEFAULTS: IEventsState = {
  version: 2,
  sessionId: null,
  webbankirId: null,
};
